let data = {
    "experience":{
        "Web Development":[{
            "image":"assets/experience/zeltatech.png",
            "url":"",
            "head":"Zeltatech Website",
            "text":"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita odit minima"
        },{
            "image":"assets/experience/portfolio.png",
            "url":"",
            "head":"Portfolio Website",
            "text":"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita odit minima"
        },{
            "image":"assets/experience/movies.png",
            "url":"",
            "head":"Movies Website",
            "text":"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita odit minima"
        },{
            "image":"assets/experience/mechanic.png",
            "url":"",
            "head":"My Mechanic",
            "text":"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita odit minima"
        }],
        "Software Development":[{
            "image":"assets/experience/wondertrove.png",
            "url":"",
            "head":"Wondertrove",
            "text":"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita odit minima"
        },{
            "image":"assets/experience/gearing-up-wallpapers.jpg",
            "url":"",
            "head":"Lorem Ipsum",
            "text":""
        },{
            "image":"assets/experience/gearing-up-wallpapers.jpg",
            "url":"",
            "head":"Lorem Ipsum",
            "text":""
        }],
        "Electronics Engineering":[{
            "image":"assets/experience/avionics.png",
            "url":"",
            "head":"Rocket Avionics",
            "text":""
        },{
            "image":"assets/experience/dark-techno-wallpapers.jpg",
            "url":"",
            "head":"Door Automation",
            "text":""
        },{
            "image":"assets/experience/dark-techno-wallpapers.jpg",
            "url":"",
            "head":"Light Automation",
            "text":""
        },{
            "image":"assets/experience/dark-techno-wallpapers.jpg",
            "url":"",
            "head":"Car Wash Tally",
            "text":""
        }],
        "Opensource contributions":[{
            "image":"assets/experience/utilities.png",
            "url":"",
            "head":"Linux Utilies",
            "text":""
        },{
            "image":"assets/experience/gearing-up-wallpapers.jpg",
            "url":"",
            "head":"Lorem Ipsum",
            "text":""
        },{
            "image":"assets/experience/gearing-up-wallpapers.jpg",
            "url":"",
            "head":"Lorem Ipsum",
            "text":""
        }],
        "Personal Projects":[{
            "image":"assets/experience/iconlogo.jpg",
            "url":"",
            "head":"OCR with Python",
            "text":""
        },{
            "image":"assets/experience/iconlogo.jpg",
            "url":"",
            "head":"GitHub Clone",
            "text":""
        },{
            "image":"assets/experience/iconlogo.jpg",
            "url":"",
            "head":"Quill Bot",
            "text":""
        },{
            "image":"assets/experience/iconlogo.jpg",
            "url":"",
            "head":"Lorem Ipsum",
            "text":""
        }]
    },
    "references":[
        {
            "name":"Avner Khan",
            "email":"avaner@explorastay.com",
            "phone":"2149574014",
            "company":"ExploraStay",
            "position":"CTO"
        },
        {
            "name":"Jacqueline Chiinngaihlian",
            "email":"jacqueline@zeltatech.com",
            "phone":"+918107157324",
            "company":"Zelta Tech",
            "position":"Chief Administrator"
        }
    ],
    "contacts":[
        {
            "logo":"assets/github.png",
            "url":""
        },
        {
            "logo":"assets/email.png",
            "url":""
        },
        {
            "logo":"assets/phone-call.png",
            "url":""
        },
        {
            "logo":"assets/linkedin.png",
            "url":""
        },
        {
            "logo":"assets/twitter.png",
            "url":""
        },
    ]
};

export default data;